import { render, staticRenderFns } from "./overlay.vue?vue&type=template&id=38a89923&scoped=true&lang=pug&"
import script from "./overlay.vue?vue&type=script&lang=coffee&"
export * from "./overlay.vue?vue&type=script&lang=coffee&"
import style0 from "./overlay.vue?vue&type=style&index=0&id=38a89923&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a89923",
  null
  
)

export default component.exports